import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-self-serve }}",{ moduleName: "embercom/templates/apps/app/automation/fin-ai-agent/sales/fin-studio.hbs" })